import { ActionReducerMapBuilder } from "../../../../common/redux/createReducer";
import { WindowServiceStore, WindowServiceRootStore } from "../types";
import { createAction, PayloadAction } from "@reduxjs/toolkit";
import Logger from "../../../../clients/logger";

const getInitialState = (): WindowServiceRootStore => {
	return {
		isVisible: false,
		quashedActions: [],
		testing: {
			unitTestingEnabled: false,
			error: "",
		},
	};
};

const actions = {
	windowVisible: createAction<boolean>("root/windowVisible"),
	quashActions: createAction<string[]>("root/quashActions"),
};

const addReducerCases = (builder: ActionReducerMapBuilder<WindowServiceStore>) => {
	builder
		.addCase(actions.windowVisible, (state, action: PayloadAction<boolean>) => {
			const isVisible = action.payload;
			state.root.isVisible = isVisible;
			Logger.log("windowService.root.windowVisible", state.windowTitleBar, action);
		})
		.addCase(actions.quashActions, (state, action) => {
			state.root.quashedActions = action.payload;
		});
};

export default {
	getInitialState,
	addReducerCases,
	actions,
};
